<template>
  <div />
</template>

<script>

/**
 * Vue: Main 404 (main-404)
 * -----------------------------------------------------------------------------
 * 404 page section.
 * - Static section.
 *
 */
export default {
  // eslint-disable-next-line max-len
  // eslint-disable-next-line vue/multi-word-component-names, vue/match-component-file-name
  name: 'Main404',

  data() {
    return {
    }
  },

  mounted() {
    this.setEventListeners()
  },

  methods: {
    setEventListeners() {
      const backCta = document.querySelector('[js-404="back"]')
      backCta.addEventListener('click', () => {
        window.history.back()
      })
    },
  },

}
</script>

<style lang="scss">
@import './main-404';
</style>
